import clsx from 'clsx';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import useDidMountEffect from '@/src/hooks/useDidMountEffect';
import { cn } from '@/src/util/ui';

import Form from './Form/Form';
import List from './List/List';

const Comments = ({
  isFullScreen,
  projectId,
  onReplying = null,
  commentListHeight = '',
  textEditorClasses = '',
}) => {
  const [isLoading] = useState(false);
  const [isReplyingTo, setIsReplyingTo] = useState(null);
  const document = useSelector((state) => state.comments.document);
  const totalCount = useSelector((state) => state.comments.totalCount);

  // This effect runs whenever document.id changes
  useDidMountEffect(() => {
    setIsReplyingTo(null);
  }, [document.id]);

  const handleIsReplyingTo = (o) => {
    setIsReplyingTo(o === isReplyingTo ? null : o);
  };

  return (
    <div
      className={clsx(
        'container--comments tw-flex tw-flex-col tw-h-full',
        !document.IsActive ? 'fileDeleted' : ''
      )}
    >
      {isFullScreen && (
        <div className="tabHeader">
          <h4>Comments {totalCount > 0 ? `(${totalCount})` : ''}</h4>
        </div>
      )}

      <List
        projectId={projectId}
        isLoading={isLoading}
        onReplying={handleIsReplyingTo}
        isReplyingTo={isReplyingTo}
        heightClasses={commentListHeight}
      />
      {document.isActive && !document.isDeleted ? (
        <Form
          projectId={projectId}
          onReplying={onReplying}
          textEditorClasses={cn(textEditorClasses)}
        />
      ) : (
        <span></span>
      )}
    </div>
  );
};
export default Comments;
